// extracted by mini-css-extract-plugin
module.exports = {"inactive":"CampaignTruckModal_inactive__O5O_S","active":"CampaignTruckModal_active__2AjMa"};